import type { TaskDefinition } from "@gearbox-protocol/deploy-tools-shared";
import { Plus } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { Link, useLoaderData } from "react-router-dom";

import TaskDefinitionsList from "./TaskDefinitionsList";

const TaskDefinitionsListRoute: FC = () => {
  const taskDefinitions = useLoaderData() as TaskDefinition[];
  return (
    <>
      <div className="flex flex-row gap-2 items-center">
        <h2 className="text-gray-100">Task definitions</h2>
        <Link to="new">
          <Plus />
        </Link>
      </div>
      <TaskDefinitionsList tasks={taskDefinitions} />
    </>
  );
};

export default TaskDefinitionsListRoute;
